<template>
    <b-modal id="attachments-modal" ref="attachments-modal" hide-footer hide-header centered scrollable size="lg">
        <div class="w-100 d-flex justify-content-between pb-2">
            <h3 class="text-white">{{ title }}</h3>
            <div class="d-flex">
                <ci-button
                    @click="downloadCurrentFile"
                    type="blue"
                    class="mr-3"
                    :loading="downloadingFile"
                    :centerIcon="{ name: 'file-download', color: 'var(--light)' }"
                />
                <ci-button type="black" :centerIcon="{ name: 'times', color: 'var(--light)' }" @click="$refs['attachments-modal'].hide()" />
            </div>
        </div>
        <swiper :class="['swiper gallery-top', attachments.length == 1 && 'use-max-height']" :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide class="w-100 h-100" v-for="(attachment, i) in attachments" :key="i">
                <p class="text-light text-12 text-weight-bold">{{ attachment.name ? attachment.name : $t('keyword184') + ' ' + (i + 1) }}</p>
                <vue-custom-scrollbar class="slide-scrollbar h-100 w-100">
                    <pdf class="w-100" v-if="attachment.extension === 'pdf' || attachment.type === 'pdf'" :src="attachment.url"></pdf>
                    <b-img class="h-100" v-else :src="attachment.url" fluid> </b-img>
                </vue-custom-scrollbar>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev" v-if="attachments.length > 1">
                <icon name="chevron-left" scale="2" color="var(--secondary-3)" />
            </div>
            <div class="swiper-button-next" slot="button-next" v-if="attachments.length > 1">
                <icon name="chevron-right" scale="2" color="var(--secondary-3)" />
            </div>
        </swiper>
        <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs" v-if="attachments.length > 1">
            <swiper-slide v-for="attachment in attachments" :key="attachment.id" :style="`background-image: url('${attachment.url}');`">
                <div
                    class="d-flex justify-content-center align-items-center h-100 w-100"
                    v-if="attachment.extension === 'pdf' || attachment.type === 'pdf'"
                    :src="attachment.url"
                >
                    <icon name="file-pdf" scale="4" color="white" />
                </div>
            </swiper-slide>
        </swiper>
    </b-modal>
</template>
<script>
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/chevron-left'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/file-download'

import VueCustomScrollbar from 'vue-custom-scrollbar'
import pdf from 'vue-pdf'

export default {
    name: 'FilesPreviewModal',
    components: {
        pdf,
        VueCustomScrollbar,
    },
    props: {
        attachments: Array,
    },
    data() {
        return {
            title: null,
            swiperOptionTop: {
                // loop: true,
                loopedSlides: 5,
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 10,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            swiperOptionThumbs: {
                // loop: true,
                loopedSlides: 5,
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: 'auto',
                touchRatio: 0.2,
                slideToClickedSlide: true,
            },
            downloadingFile: false,
        }
    },
    methods: {
        downloadCurrentFile() {
            let attachment = this.attachments[this.$refs.swiperTop.swiper.activeIndex]
            if (attachment) {
                this.downloadingFile = true
                fetch(attachment.url)
                    .then((resp) => resp.blob())
                    .then((blob) => {
                        const url = window.URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.style.display = 'none'
                        a.href = url
                        a.download = 'CIN-ISSUE-ATTCHMENT-' + attachment.id + '.' + (attachment.type || attachment.exentension)
                        document.body.appendChild(a)
                        a.click()
                        window.URL.revokeObjectURL(url)
                        this.downloadingFile = false
                    })
                    .catch(() => {
                        this.downloadingFile = false
                    })
            }
        },
        show(index = 0, title = '') {
            this.title = title
            this.$refs['attachments-modal'].show()
            setTimeout(() => {
                this.$refs.swiperTop.update()
                this.$refs.swiperThumbs.update()
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
                swiperTop.slideTo(index)
            }, 250)
        },
    },
}
</script>

<style lang="scss">
#attachments-modal {
    .modal-content {
        height: 80vh;
    }
    .inside-relative {
        position: relative;
        .inside-absolute {
            position: absolute;
            left: 100%;
        }
    }
    .swiper {
        .swiper-slide {
            background-size: cover;
            background-position: center;
        }
        &.gallery-top {
            height: 80%;
            width: 100%;
            @media (max-width: 1400px) {
                height: 73%;
            }

            &.use-max-height {
                height: 90%;
            }
        }
        &.gallery-top .swiper-slide {
            .slide-scrollbar {
                display: flex;
                justify-content: center;
            }
        }
        &.gallery-thumbs {
            height: 10%;
            box-sizing: border-box;
            padding-top: 10px;
            @media (max-width: 1400px) {
                height: 15%;
            }
        }
        &.gallery-thumbs .swiper-slide {
            width: 25%;
            height: 100%;
            opacity: 0.4;
            cursor: pointer;
        }
        &.gallery-thumbs .swiper-slide-active {
            opacity: 1;
        }
    }
    .swiper-button-next {
        background-image: none !important;
    }
    .swiper-button-prev {
        background-image: none !important;
    }
}
</style>
